import { createStore, applyMiddleware } from 'redux';
import { persistStore, persistReducer } from 'redux-persist';
import { loadingBarMiddleware } from 'react-redux-loading-bar';
import storage from 'redux-persist/lib/storage';
import thunk from 'redux-thunk-fsa';
import promise from 'redux-promise';
import rootReducer from './reducers';

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['auth'],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const middleware = [
  thunk.withOpts({
    interrupt: true,
    next: true,
  }),
  promise,
];

export const store = createStore(
  persistedReducer,
  applyMiddleware(loadingBarMiddleware(), ...middleware)
);
export const persistor = persistStore(store);

export default store;
